export const allowed4DigitsNumbersForDojinshi = [
  [
    [],
    [112],
    [120, 121, 122, 123, 124, 125, 126, 127, 128, 129],
    [130, 131, 132, 133, 134, 135, 136, 137, 138, 139],
    [140, 141, 142, 143, 144, 145, 146, 147, 148, 149],
    [150, 151, 152, 153, 154, 155, 156, 157, 158, 159],
    [160, 161, 162, 163, 164, 165, 166, 167, 168, 169],
    [170, 171, 172, 173, 174, 175, 176, 177, 178, 179],
    [180, 181, 182, 183, 184, 185, 186, 187, 188, 189],
    [190, 191, 192, 193, 194, 195, 196, 197, 198, 199],
  ],
  [
    [],
    [],
    [220, 221, 222, 223, 224, 225, 226, 227, 228, 229],
    [230, 231, 232, 233, 234, 235, 236, 237, 238, 239],
    [240, 241, 242, 243, 244, 245, 246, 247, 248, 249],
    [250, 251, 252, 253, 254, 255, 256, 257, 258, 259],
    [260, 261, 262, 263, 264, 265, 266, 267, 268, 269],
    [270, 271, 272, 273, 274, 275, 276, 277, 278, 279],
    [280, 281, 282, 283, 284, 285, 286, 287, 288, 289],
    [290, 291, 292, 293, 294, 295, 296, 297, 298, 299],
  ],
  [[], [], [], [331], [], [], [], [], [], []],
  [
    [],
    [],
    [420, 421, 422, 423, 424, 425, 426, 427, 428, 429],
    [430, 431, 432, 433, 434, 435, 436, 437, 438, 439],
    [442],
    [452],
    [460, 461, 462, 463, 464, 465, 466, 467, 468, 469],
    [470, 471, 472, 473, 474, 475, 476, 477, 478, 479],
    [480, 481, 482, 483, 484, 485, 486, 487, 488, 489],
    [490, 491, 492, 493, 494, 495, 496, 497, 498, 499],
  ],
  [
    [],
    [],
    [522],
    [530, 531, 532, 533, 534, 535, 536, 537, 538, 539],
    [540, 541, 542, 543, 544, 545, 546, 547, 548, 549],
    [550, 551, 552, 553, 554, 555, 556, 557, 558, 559],
    [560, 561, 562, 563, 564, 565, 566, 567, 568, 569],
    [570, 571, 572, 573, 574, 575, 576, 577, 578, 579],
    [580, 581, 582, 583, 584, 585, 586, 587, 588, 589],
    [590, 591, 592, 593, 594, 595, 596, 597, 598, 599],
  ],
  [[], [], [], [], [641], [], [], [], [], []],
  [
    [],
    [],
    [720, 721, 722, 723, 724, 725, 726, 727, 728, 729],
    [730, 731, 732, 733, 734, 735, 736, 737, 738, 739],
    [740, 741, 742, 743, 744, 745, 746, 747, 748, 749],
    [752],
    [760, 761, 762, 763, 764, 765, 766, 767, 768, 769],
    [770, 771, 772, 773, 774, 775, 776, 777, 778, 779],
    [782],
    [790, 791, 792, 793, 794, 795, 796, 797, 798, 799],
  ],
  [
    [],
    [],
    [820, 821, 822, 823, 824, 825, 826, 827, 828, 829],
    [830, 831, 832, 833, 834, 835, 836, 837, 838, 839],
    [840, 841, 842, 843, 844, 845, 846, 847, 848, 849],
    [850, 851, 852, 853, 854, 855, 856, 857, 858, 859],
    [860, 861, 862, 863, 864, 865, 866, 867, 868, 869],
    [870, 871, 872, 873, 874, 875, 876, 877, 878, 879],
    [880, 881, 882, 883, 884, 885, 886, 887, 888, 889],
    [890, 891, 892, 893, 894, 895, 896, 897, 898, 899],
  ],
  [
    [],
    [],
    [920, 922, 923],
    [930, 932],
    [940, 941, 942, 943, 944, 945, 946, 947, 948, 949],
    [950, 951, 952, 953, 954, 955, 956, 957, 958, 959],
    [960, 961, 962, 963, 964, 965, 966, 967, 968, 969],
    [970, 971, 972, 973, 974, 975, 976, 977, 978, 979],
    [980, 981, 982, 983, 984, 985, 986, 987, 988, 989],
    [990, 991, 992, 993, 994, 995, 996, 997, 998, 999],
  ],
]

export const allowed4DigitsNumbersByExcludedZeroMA = [
  [
    [],
    [112],
    [123, 124, 125, 126],
    [133, 134, 135, 136, 137, 138, 139],
    [142, 143, 144, 145, 146],
    [152, 153, 154, 155, 156, 157, 158],
    [162, 163, 164, 165, 166, 167],
    [171, 172, 173, 174, 175, 176, 177, 178, 179],
    [181, 182, 183, 184, 185, 186, 187, 188],
    [191, 192, 193, 194, 195, 196, 197, 198, 199],
  ],
  [
    [],
    [],
    [220, 221, 222, 223, 224, 225, 226, 227, 228, 229],
    [231, 233, 234, 235, 236, 237, 238],
    [240, 241, 242, 243, 244, 245, 246, 247, 248, 249],
    [250, 251, 252, 253, 254, 255, 256, 257, 258, 259],
    [260, 261, 262, 263, 264, 265, 266, 267, 268, 269],
    [270, 271, 272, 273, 274, 276, 277, 278, 279],
    [280, 281, 282, 283, 284, 285, 286, 287, 288, 289],
    [291, 292, 293, 294, 295, 296, 297, 298, 299],
  ],
  [[], [], [], [331], [], [], [], [], [], []],
  [
    [],
    [],
    [420, 422, 423, 424, 425, 426, 427, 428, 429],
    [431, 432, 433, 434, 436, 438, 439],
    [442],
    [452],
    [460, 462, 463, 464, 465, 466, 467, 468],
    [470, 471, 473, 474, 475, 476, 477, 478, 479],
    [480, 481, 482, 484, 485, 486, 487, 488, 489],
    [491, 492, 493, 494, 495, 499],
  ],
  [
    [],
    [],
    [522],
    [531, 532, 533, 534, 535, 536, 537, 538, 539],
    [541, 542, 543, 544, 545, 546, 547, 548, 549],
    [550, 551, 552, 553, 554, 555, 556, 557, 558, 559],
    [561, 562, 563, 564, 565, 566, 567, 568, 569],
    [572, 573, 574, 575, 576, 577, 578],
    [581, 582, 583, 584, 585, 586, 587],
    [591, 592, 593, 594, 595, 596, 597, 598, 599],
  ],
  [[], [], [], [], [641], [], [], [], [], []],
  [
    [],
    [],
    [721, 722, 723, 724, 725, 726, 727, 728, 729],
    [731, 734, 735, 736, 737, 738, 739],
    [740, 742, 743, 744, 745, 746, 747, 748, 749],
    [752],
    [761, 762, 763, 764, 765, 766, 767, 768],
    [770, 771, 772, 773, 774, 775, 776, 778, 779],
    [782],
    [790, 791, 792, 793, 794, 795, 796, 797, 798, 799],
  ],
  [
    [],
    [],
    [820, 821, 822, 823, 824, 825, 826, 827, 828, 829],
    [832, 833, 834, 835, 836, 837, 838, 839],
    [841, 845, 846, 847, 848, 849],
    [851, 852, 853, 854, 855, 856, 857, 858, 859],
    [861, 862, 863, 864, 865, 866, 867, 868, 869],
    [871, 875, 877, 878, 879],
    [880, 883, 884, 885, 886, 887, 888, 889],
    [891, 892, 893, 894, 895, 896, 897, 898, 899],
  ],
  [
    [],
    [],
    [920, 922, 923],
    [930, 932],
    [940, 942, 943, 944, 946, 947, 948, 949],
    [950, 951, 952, 954, 955, 956, 957, 958, 959],
    [961, 962, 963, 964, 965, 966, 967, 968, 969],
    [971, 972, 973, 974, 975, 977, 978, 979],
    [980, 981, 982, 983, 984, 985, 986, 987, 988, 989],
    [991, 992, 993, 994, 995, 996, 997, 998],
  ],
]
